// ------------------------------------
// Import SCSS files
// ------------------------------------
import "../sass/front-page.scss";
import "./components/readmore";
// import "./components/slider";